export default __webpack_public_path__ + "static/media/thumbnail0.9ab88359.jpg";